import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { ShelterGetArticlesQuery, ShelterGetArticlesQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';

export const SHELTER_GET_ARTICLES = graphql(`
  query ShelterGetArticles(
    $where: ArticleWhereInput
    $orderBy: [ArticleOrderByWithRelationAndSearchRelevanceInput!]
    $take: Int
    $articleCardInfoTranslationsWhere: ArticleTranslationsWhereInput
  ) {
    findManyArticle(where: $where, orderBy: $orderBy, take: $take, randomOrder: true) {
      ...ArticleCardInfo
    }
  }
`);

export const useGetArticles = () => {
  const { languageCode } = useRouter();

  const variables = useMemo((): ShelterGetArticlesQueryVariables => {
    return {
      take: 4,
      where: {
        AND: [
          {
            translations: {
              some: {
                AND: [
                  { languageCode: { equals: languageCode } },
                  { url: { not: { equals: '' } } },
                  { url: { not: { equals: undefined } } },
                  { title: { not: { equals: '' } } },
                  { title: { not: { equals: undefined } } },
                ],
              },
            },
          },
          { tags: { hasSome: ['shelters', 'breeds', 'advise'] } },
          { published: { equals: true } },
        ],
      },
      articleCardInfoTranslationsWhere: {
        languageCode: { equals: languageCode },
        active: { equals: true },
      },
    };
  }, [languageCode]);

  const { data, error, loading } = useQuery<
    ShelterGetArticlesQuery,
    ShelterGetArticlesQueryVariables
  >(SHELTER_GET_ARTICLES, {
    variables,
    notifyOnNetworkStatusChange: true,
    ssr: false,
  });

  return {
    articles: data?.findManyArticle ?? [],
    articlesError: error,
    articlesLoading: loading,
  };
};
